import { MemoryArea } from './MemoryArea';
import { ForceMask } from './ForceMask';

export class ProcessImage {
  public readonly inputs: MemoryArea;
  public readonly outputs: MemoryArea;
  public readonly memory: MemoryArea;

  public readonly inputForces: ForceMask;
  public readonly outputForces: ForceMask;
  public readonly memoryForces: ForceMask;

  constructor(
    public readonly inputSize: number,
    public readonly outputSize: number,
    public readonly memorySize: number,
  ) {
    this.inputs = new MemoryArea(inputSize);
    this.outputs = new MemoryArea(outputSize);
    this.memory = new MemoryArea(memorySize);

    this.inputForces = new ForceMask(inputSize);
    this.outputForces = new ForceMask(outputSize);
    this.memoryForces = new ForceMask(memorySize);
  }

  /**
   * Called at the beginning of the PLC scan cycle.
   * Copies physical IO states into the Process Image Input (PII) and applies forces.
   */
  readInputs(physicalInputs: Uint8Array): void {
    const len = Math.min(this.inputs.sizeBytes, physicalInputs.length);
    for (let i = 0; i < len; i += 1) {
      this.inputs.buffer[i] = physicalInputs[i] ?? 0;
    }
    // Apply forces
    this.inputForces.applyTo(this.inputs.buffer);
    this.memoryForces.applyTo(this.memory.buffer);
  }

  /**
   * Called at the end of the PLC scan cycle.
   * Applies output forces, then copies Process Image Output (PIQ) to physical IO buffers.
   */
  writeOutputs(physicalOutputs: Uint8Array): void {
    this.outputForces.applyTo(this.outputs.buffer);

    const len = Math.min(this.outputs.sizeBytes, physicalOutputs.length);
    for (let i = 0; i < len; i += 1) {
      physicalOutputs[i] = this.outputs.buffer[i] ?? 0;
    }
  }

  reset(): void {
    this.inputs.reset();
    this.outputs.reset();
    this.memory.reset();
    this.inputForces.clearAll();
    this.outputForces.clearAll();
    this.memoryForces.clearAll();
  }
}
